import create from 'zustand'
import produce from 'immer'
import { persist } from 'zustand/middleware'
import { formatPrice } from '../helpers/utils'
import { AddOnCartStore, getAdditionalProductsTotal } from './AddOnProductStore'
import { getTotalQuantityCampaignProduct } from '../helpers/slug'
import localforage from 'localforage'
import {
    removeDiscountFromAddOn,
    removeDiscountFromCart,
} from '../helpers/checkout'

/*
 @link https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
*/
const Storage = {
    getItem: async (name) => {
        return (await localforage.getItem(name)) || null
    },
    setItem: async (name, value) => {
        await localforage.setItem(name, value)
    },
    removeItem: async (name) => {
        await localforage.removeItem(name)
    },
}

/**
 * We need to proive cart to it, to make sure its reactive
 */
export const getCartTotalElements = ({ cart, coupons, addOnProducts }) => {
    let subtotal = 0
    let discount = 0
    let total = 0

    subtotal = cart.reduce((acc, item) => {
        return (
            acc +
            parseFloat(item.price) *
                Number(getTotalQuantityCampaignProduct(item))
        )
    }, 0)

    const addOnsTotal = getAdditionalProductsTotal({ cart, addOnProducts })
    subtotal = addOnsTotal + subtotal

    subtotal = formatPrice(subtotal)

    /** we supporting only one coupon right now */
    const coupon = coupons[0]
    if (coupon) {
        discount = coupon.amount
        total = subtotal - discount
    } else {
        total = subtotal
    }

    total = formatPrice(total)
    discount = formatPrice(discount)

    return [total, subtotal, discount]
}

export const CartStore = create(
    persist(
        (set) => ({
            cart: [],
            coupon_lines: [],
            add: (item) => {
                set(
                    produce((draft) => {
                        draft.cart.push(item)
                        draft.coupon_lines = [] // remove coupon
                        draft.cart = removeDiscountFromCart(draft.cart)
                        removeDiscountFromAddOn()
                    }),
                )
            },
            remove: (key) => {
                set(
                    produce((draft) => {
                        const removeAddOn =
                            AddOnCartStore.getState().removeByProduct
                        removeAddOn(key)
                        draft.cart = draft.cart.filter(
                            (item) => item._key != key,
                        )
                        draft.coupon_lines = [] // remove coupon
                        draft.cart = removeDiscountFromCart(draft.cart)
                        removeDiscountFromAddOn()
                    }),
                )
            },
            reset: () => {
                set(
                    produce((draft) => {
                        draft.cart = []
                        draft.coupon_lines = []
                    }),
                )
            },
            setCart: (cart) => {
                set(
                    produce((draft) => {
                        draft.cart = cart
                    }),
                )
            },
            addCoupon: (item) => {
                set(
                    produce((draft) => {
                        // draft.coupon_lines.push(item)
                        draft.coupon_lines = [item] // only one coupon supported
                    }),
                )
            },
            removeCoupon: () => {
                set(
                    produce((draft) => {
                        draft.coupon_lines = [] // only one coupon supported
                        draft.cart = removeDiscountFromCart(draft.cart)
                        removeDiscountFromAddOn()
                        // draft.coupon_lines.splice(idx, 1)
                    }),
                )
            },
        }),
        {
            name: `olm-cart-${process.env.NEXT_PUBLIC_STORE_SUFFIX}`,
            getStorage: () => Storage,
        },
    ),
)
